export default __webpack_public_path__ + "static/media/cat_jachtverhuurder.b765eef9.svg";